import React from 'react';
import { useContext, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { TopBarContext, MobileNavButtonDescriptor } from '@/common/layouts/AuthLayout/TopBarContext';
import MobileFileViewer from '../../components/file-viewing/MobileFileViewer';
import { MobilePageContent, Title, BodyText, Subtitle } from '@/mobile/layouts/common/MobilePageStyles';

const MobileResourceViewerPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams<{ fileId: string }>();
  const { setTopBarContent, setNavButton } = useContext(TopBarContext);

  const title = (location.state as any)?.title || 'Resource Viewer';
  const fileId = params.fileId;

  useEffect(() => {
    const closeNavButton: MobileNavButtonDescriptor = {
      type: 'close',
      onClick: () => navigate(-1),
    };

    setNavButton(closeNavButton);
    setTopBarContent(
      <TopBarSubtitle>
        {title}
      </TopBarSubtitle>
    );

    return () => {
      setNavButton(null);
      setTopBarContent(null);
    };
  }, [navigate, setNavButton, setTopBarContent, title]);

  if (!fileId) {
    return (
      <MobilePageContent>
        <Title>Resource not found</Title>
        <BodyText>The resource you requested could not be found.</BodyText>
      </MobilePageContent>
    );
  }

  return (
    <MobilePageContent>
      <ViewerWrapper>
        <MobileFileViewer
          fileId={fileId}
          isFullScreen
          style={{ width: '100%', minHeight: 0, minWidth: 0, height: '100%', padding: 0 }}
        />
      </ViewerWrapper>
    </MobilePageContent>
  );
};

export default MobileResourceViewerPage;

const ViewerWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 170px);
  max-height: calc(100vh - 170px);
  min-width: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background: #ffffff;
`;

const TopBarSubtitle = styled(Subtitle)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
